import { Pipe, PipeTransform } from '@angular/core';
import writtenNumber from 'written-number';

@Pipe({
  name: 'montantLettre'
})
export class MontantLettrePipe implements PipeTransform {

  transform(value: number): string {
    if (value === null || value === undefined) {
      return '';
    }

    const dinars = Math.floor(value);
    const millimes = Math.round((value - dinars) * 1000);

    let texte = writtenNumber(dinars, { lang: 'fr' }) + ' dinar';
    if (dinars > 1) texte += 's';

    if (millimes > 0) {
      texte += ' et ' + writtenNumber(millimes, { lang: 'fr' }) + ' millime';
      if (millimes > 1) texte += 's';
    }

    return texte;
  }
}